import { Cache } from '@models/app.types'
import { NotificationFieldsFragment } from '@src/graphql/fragments/notification.generated'
import { LiveNotificationsQuery } from '@src/graphql/liveNotifications.generated'
import { Notification, NotificationInboxStateFilter } from '@src/types'

export type NotificationRecord = NotificationFieldsFragment
export type LiveNotificationRecord = LiveNotificationsQuery['liveNotifications']['notifications'][number]

export interface NotificationInboxListState {
  records: NotificationRecord[]
  nextCursor: string | null
}

export interface NotificationInboxState {
  unreadCount: number
  notifications: Partial<Record<NotificationInboxStateFilter, NotificationInboxListState>>
}

export interface NotificationsStoreState {
  cache: Cache
  lastFetchedAt: string | null
  notifications: Notification[]
  liveNotifications: LiveNotificationRecord[]
  inbox: NotificationInboxState
}

export const DEFAULT_NOTIFICATION_INBOX_LIST_STATE: NotificationInboxListState = {
  records: [],
  nextCursor: null,
}
